import { HAS_WINDOW } from '@eventbrite/feature-detection';

export const postMessage = (
    messageName: string,
    eventId: string,
    widgetParentUrl: string,
    additionalData: object = {},
): Promise<void> => {
    // You would only not have a widgetParentUrl if you access /checkout-external directly,
    // which sometimes we want to do for testing
    if (widgetParentUrl) {
        HAS_WINDOW &&
            window.parent.postMessage(
                {
                    ...additionalData,
                    messageName,
                    eventId,
                },
                widgetParentUrl,
            );
    }

    return Promise.resolve();
};
